import { FormProvider, type SubmitHandler, useForm } from "react-hook-form";
import GmdssDetailsForm from "src/components/pages/Settings/YachtSetUp/GmdssDetailsForm";
import YachtSetupSectionHeader from "src/components/pages/Settings/YachtSetUp/YachtSetupSectionHeader";
import Loader from "src/components/shared/Loader/Loader";
import { useGetApi, usePostApi } from "src/hooks";
import { PageContainer } from "src/styled";
import { getYachtId } from "src/utils";
import { Notification } from "src/utils/Notification";

import { type IGmdssSetupForm } from "./GmdssSetup.types";
import { mapGmdssSetup } from "./GmdssSetup.utils";

const GmdssSetup = () => {
  const { data, isLoading: isGetLoading } = useGetApi({
    request: "get-settings",
    body: { params: { sect: "_particulars" } },
    mapper: mapGmdssSetup,
  });
  const { post, isLoading: isPostLoading } = usePostApi();

  const methods = useForm<IGmdssSetupForm>({
    values: data,
  });

  const onSubmit: SubmitHandler<IGmdssSetupForm> = async data => {
    await post({
      request: "save-yacht-info",
      body: { params: { data, section: "gmdss", yachtid: getYachtId() } },
      onSuccess: () => {
        methods.reset(data);
        Notification(
          "Success",
          "GMDSS Set Up has been successfully changed.",
          "green",
        );
      },
    });
  };

  return (
    <PageContainer>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <YachtSetupSectionHeader isSaving={isPostLoading} section="gmdss" />
          {!data || isGetLoading ? (
            <Loader />
          ) : (
            <GmdssDetailsForm data={data} />
          )}
        </form>
      </FormProvider>
    </PageContainer>
  );
};

export default GmdssSetup;
